import { dictionary } from '../../dictionary';

export const navItems = [
  { label: dictionary.general.navLinks.articles, path: '/articles' },
  { label: dictionary.general.navLinks.about, path: '/about' },
  { label: dictionary.general.navLinks.contact, path: '/contact' },
];

export const mobileNavItems = [
  { label: dictionary.general.navLinks.home, path: '/' },
  ...navItems,
];
